import React from "react";
import { Grid } from "@mui/material";
import { Card } from "components/haven-design/card";
import { getQueryParam } from "utils/url";
import { HavenConnectLoginLogo, LoginCardTitle, LoginCardSubtitle } from "components/login/components/shared-components";
import { loginStyles } from "./styles";

const CheckEmail: React.FC = () => {
  const email = getQueryParam("email") || "";
  return (
    <Grid container justifyContent="center" spacing={2} direction="row">
      <Grid size={{ xs: 12 }}>
        <HavenConnectLoginLogo />
      </Grid>

      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
      >
        <Card style={loginStyles.card}>
          <Grid>
            <LoginCardTitle title="Check your email" />
          </Grid>

          <Grid>
            <LoginCardSubtitle>
                Check your email at <strong>{email.replace(" ", "+")}</strong> for instructions on how to
                reset your password. You may need to check your spam folder for the email.
            </LoginCardSubtitle>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
};

export default CheckEmail;
